import { toast } from "react-toastify";

export function handleSuccess(msg) {
  toast.success(msg, {
    position: "top-right",
    autoClose:3000,
  });
}

export function handleError(msg) {
  toast.error(msg, {
    position: "top-right",
    autoClose: 3000,
  });
}

export function getUserNameFromStoreData(data) {
  return `${data.user[0].first_name} ${data.user[0].last_name}`
}

export function handleLogout() {
  localStorage.clear();
  window.location.href = '/';
};

/**
 * Converts a file to a Base64 string.
 * @param {File} file - The file to be converted.
 * @returns {Promise<string>} A promise that resolves to the Base64 string of the file.
 */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    // Event triggered when the file is successfully read
    reader.onload = () => {
      resolve(reader.result); // Extract only the Base64 part
    };

    // Event triggered if there's an error reading the file
    reader.onerror = () => {
      reject(new Error('Error reading file'));
    };

    // Start reading the file as a Data URL
    reader.readAsDataURL(file);
  });
}

function padBase64(base64) {
  while (base64.length % 4 !== 0) {
    base64 += '=';
  }
  return base64;
}

export function setMockFile(fileName, fieldId) {
  const mockFile = new File(["Hello, world!"], fileName, { type: "text/plain" });

  // Create a DataTransfer object to simulate a file input
  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(mockFile);
  
  // Get the file input element
  const fileInput = document.querySelector('#'+ fieldId);
  // Set the mock file to the file input
  fileInput.files = dataTransfer.files;
}

function getContentTypeFromBase64(base64) {
  const match = base64.match(/^data:(.*?);base64,/);
  return match ? match[1] : null;
}

export function base64ToBlob (base64, contentType='') {
  try {
    contentType = getContentTypeFromBase64(base64);
    const byteCharacters = atob(base64.split(',')[1]);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    const blob = new Blob([byteArray], { type: contentType });
    return URL.createObjectURL(blob);
  } catch (e) {
    console.log(e);
  }
}